import { gql } from '@apollo/client';

export const ACTIVITY_UPSERT = gql`
  mutation upsertActivity($input: activityInput!) {
    upsertActivity(input: $input) {
      recordId
      month
      nbDaysWorked
      nbDaysMarkupWorked
      nbDaysMarkup2Worked
      recordIdMission
      astreinte
      hoursPerDays
    }
  }
`;

export const SIGN_BLOOMER_ACTIVITY = gql`
  mutation signBloomerActivity($activityRecordID: ID!, $signerFullname: String) {
    signBloomerActivity(activityRecordID: $activityRecordID, signerFullname: $signerFullname) {
      recordId
      month
      nbDaysWorked
      nbDaysMarkupWorked
      nbDaysMarkup2Worked
      nbDaysDetails
      astreinte
      billed
      validated
      signing
      signingDocumentId
      signedCount
      urlCraS3
      urlInvoicesS3
      urlAdditionalInvoicesS3
      signingEmbedBloomerId
      payed
      lastSupplierError
      supplierInvoiceStatus
      externalSupplierInvoiceId
      hoursPerDays
      CRAStatus
    }
  }
`;

export const SIGN_CLIENT_ACTIVITY = gql`
  mutation signClientActivity($signingDocumentID: ID!, $signerFullname: String) {
    signClientActivity(signingDocumentID: $signingDocumentID, signerFullname: $signerFullname) {
      recordId
      month
      nbDaysWorked
      nbDaysMarkupWorked
      nbDaysMarkup2Worked
      nbDaysDetails
      astreinte
      billed
      validated
      signing
      signingDocumentId
      signedCount
      urlCraS3
      signingEmbedBloomerId
      signingEmbedClientId
      payed
      lastSupplierError
      supplierInvoiceStatus
      externalSupplierInvoiceId
      hoursPerDays
      CRAStatus
      mission {
        recordId
        contactOperations {
          recordId
          email
        }
        clientSocietyName
        bloomerFullName
        label
      }
    }
  }
`;

export const CANCEL_SIGN_BLOOMER_ACTIVITY = gql`
  mutation cancelSignBloomerActivity($activityRecordID: ID!) {
    cancelSignBloomerActivity(activityRecordID: $activityRecordID) {
      recordId
      month
      nbDaysWorked
      nbDaysMarkupWorked
      nbDaysMarkup2Worked
      nbDaysDetails
      astreinte
      billed
      validated
      signing
      signingDocumentId
      signedCount
      urlCraS3
      urlInvoicesS3
      urlAdditionalInvoicesS3
      signingEmbedBloomerId
      payed
      lastSupplierError
      supplierInvoiceStatus
      externalSupplierInvoiceId
      hoursPerDays
      CRAStatus
    }
  }
`;
export const UPLOAD_ACTIVITY_FILE = gql`
  mutation uploadActivityFile($input: uploadActivityInput!) {
    uploadActivityFile(input: $input)
  }
`;

export const CREATE_ACTIVITY_CUSTOMER_INVOICE = gql`
  mutation createActivityCustomerInvoice($activityRecordID: ID!, $force: Boolean) {
    createActivityCustomerInvoice(activityRecordID: $activityRecordID, force: $force) {
      id
      processedOn
      progress
    }
  }
`;

export const CREATE_ACTIVITY_CUSTOMER_INVOICE_RETRY = gql`
  mutation createActivityCustomerInvoiceRetry($activityRecordID: ID!, $force: Boolean) {
    createActivityCustomerInvoiceRetry(activityRecordID: $activityRecordID, force: $force) {
      id
      processedOn
      progress
    }
  }
`;

export const CREATE_ACTIVITY_SUPPLIER_INVOICE = gql`
  mutation createActivitySupplierInvoice($activityRecordID: ID!, $force: Boolean, $byPassComplianceCheck: Boolean) {
    createActivitySupplierInvoice(
      activityRecordID: $activityRecordID
      force: $force
      byPassComplianceCheck: $byPassComplianceCheck
    ) {
      id
      processedOn
      progress
    }
  }
`;

export const CREATE_ACTIVITY_SUPPLIER_INVOICE_RETRY = gql`
  mutation createActivitySupplierInvoiceRetry(
    $activityRecordID: ID!
    $force: Boolean
    $byPassComplianceCheck: Boolean
  ) {
    createActivitySupplierInvoiceRetry(
      activityRecordID: $activityRecordID
      force: $force
      byPassComplianceCheck: $byPassComplianceCheck
    ) {
      id
      processedOn
      progress
    }
  }
`;

export const CREATE_BILLING_CUSTOMER_INVOICE = gql`
  mutation createBillingCustomerInvoice($billingRecordID: ID!, $force: Boolean) {
    createBillingCustomerInvoice(billingRecordID: $billingRecordID, force: $force) {
      id
      processedOn
      progress
    }
  }
`;

export const UPSERT_BLOOMER = gql`
  mutation upsertBloomer($input: bloomerInput!) {
    upsertBloomer(input: $input) {
      recordId
      firstname
      lastname
      email
      secondaryEmail
      phoneNumber
      slack
      credentialID
      communicationType
      accountManager {
        recordId
      }
      mission {
        recordId
      }
    }
  }
`;

export const FINISH_INVITATION = gql`
  mutation finishInvitation($token: String!) {
    finishInvitation(token: $token)
  }
`;

export const CLIENT_RELAUNCH_CRA = gql`
  mutation relaunchInviteClientCRA($signingDocumentId: ID!) {
    relaunchInviteClientCRA(signingDocumentId: $signingDocumentId)
  }
`;

export const UPSERT_BILLING = gql`
  mutation upsertBilling($input: BillingInput!) {
    upsertBilling(input: $input) {
      customerName
      salesPriceWithoutTaxes
      trialPeriodEndDate
      billingDate
      description
      nextStep
      recordId
      billed
      externalId
      billingContactFullname
      replacement
      paymentTerms
      origin
      cancelled
      lastCustomerInvoiceError
      taxes
      externalCustomerInvoiceId
      externalCustomerInvoiceUrl
      bdc
      businessType
      invoiceStatus
      paymentTermsDetails
    }
  }
`;

export const BOOM_MUTATION = gql`
  mutation boomUpdate {
    boomUpdate
  }
`;

export const BLOOMER_RELAUNCH_CRA = gql`
  mutation relaunchBloomerCRA($missionId: ID!, $month: Date) {
    relaunchBloomerCRA(missionId: $missionId, month: $month)
  }
`;

export const DECLARE_ZERO_ACTIVITY_FOR_MISSION = gql`
  mutation declareZeroActivityForMission($input: DeclareZeroActivityForMissionInput!) {
    declareZeroActivityForMission(input: $input) {
      recordId
      month
      CRAStatus
    }
  }
`;

export const ENSURE_ACTIVITY_FOR_MISSION = gql`
  mutation ensureActivityForMission($input: CreateActivityForMissionInput!) {
    ensureActivityForMission(input: $input) {
      recordId
      month
      CRAStatus
      validated
    }
  }
`;

export const UPDATE_PREFERENCES = gql`
  mutation updatePreferences($preferences: PreferencesInput) {
    updatePreferences(preferences: $preferences)
  }
`;

export const DELETE_MISSION = gql`
  mutation deleteMission($missionId: String!, $lostReason: DeleteMissionLostPostWinReason!, $otherLostReason: String) {
    deleteMission(missionId: $missionId, lostReason: $lostReason, otherLostReason: $otherLostReason) {
      message
    }
  }
`;

export const STOP_MISSION = gql`
  mutation stopMission($endMission: String!, $recordId: ID!) {
    stopMission(endMission: $endMission, recordId: $recordId)
  }
`;

export const CREATE_MISSION_AMENDMENT = gql`
  mutation createMissionAmendment($input: CreateMissionAmendmentGQLInput!) {
    createMissionAmendment(input: $input)
  }
`;

export const UPDATE_MISSION = gql`
  mutation updateMission($input: UpdateMissionGQLInput) {
    updateMission(input: $input) {
      recordId
    }
  }
`;

export const UPSERT_NPS_FOLLOWUP = gql`
  mutation missionFollowUp($input: NPSScoringInput) {
    missionFollowUp(input: $input) {
      recordId
    }
  }
`;

export const UPDATE_NOTIFICATION = gql`
  mutation updateNotification($recordId: ID, $read: Boolean) {
    updateNotification(recordId: $recordId, read: $read) {
      recordId
    }
  }
`;

export const DELETE_ALL_NOTIFICATION = gql`
  mutation deleteAllNotification {
    deleteAllNotification
  }
`;

export const READ_ALL_NOTIFICATION = gql`
  mutation readAllNotification {
    readAllNotification
  }
`;

export const UPSERT_SOCIETY = gql`
  mutation upsertSociety($input: societyInput!) {
    upsertSociety(input: $input) {
      recordId
      name
      status
      siret
      orderNumberRequired
      mission {
        recordId
      }
    }
  }
`;

export const UPSERT_BLOOMER_SOCIETY = gql`
  mutation upsertBloomerSociety($input: bloomerSocietyInput!) {
    upsertBloomerSociety(input: $input) {
      recordId
      name
      status
      siret
      bloomerBillingMission
      IBAN
      BIC
      KBIS
      KbisExpirationDate
      URSSAFVigilanceCertificate
      URSSAFVCExpirationDate
      RCPVigilanceCertificate
      RCPExpirationDate
      portage
      addressCountryCode
      tva
    }
  }
`;

export const UPSERT_EXTESION_ASSESSMENT = gql`
  mutation upsertExtensionAssessment($input: UpsertExtensionAssessmentGQLInput) {
    upsertExtensionAssessment(input: $input) {
      missionId
      assessment
      newEndDate
      createdBy
      createdAt
      updatedBy
      updatedAt
    }
  }
`;

export const UPLOAD_AMENDMENT = gql`
  mutation uploadAmendment($input: UploadAmendmentGQLInput!) {
    uploadAmendment(input: $input) {
      recordId
      type
      step
      status
      nbSigner
      signedCount
      emptyFileUrl
      signedFileUrl
      signedDate
      externalDocumentId
    }
  }
`;

export const RELAUNCH_LEGAL_CONTRACT_SIGNATURE = gql`
  mutation relaunchLegalContractSignature($legalContractRecordId: ID!) {
    relaunchLegalContractSignature(legalContractRecordId: $legalContractRecordId)
  }
`;

export const CANCEL_LEGAL_CONTRACT_SIGNATURE = gql`
  mutation cancelLegalContractSignature(
    $legalContractRecordId: ID!
    $reason: String
    $reasonCategory: CancelSignatureReason
  ) {
    cancelLegalContractSignature(
      legalContractRecordId: $legalContractRecordId
      reason: $reason
      reasonCategory: $reasonCategory
    ) {
      id
    }
  }
`;

export const DELETE_ACTIVITY_SUPPLIER_INVOICE = gql`
  mutation deleteActivitySupplierInvoice($activityRecordID: ID!, $force: Boolean) {
    deleteActivitySupplierInvoice(activityRecordID: $activityRecordID, force: $force) {
      id
    }
  }
`;

export const VALIDATE_CRA = gql`
  mutation validateCRA($activityRecordID: ID!, $validate: Boolean, $signerFullname: String) {
    validateCRA(activityRecordID: $activityRecordID, validate: $validate, signerFullname: $signerFullname) {
      recordId
      validated
    }
  }
`;

export const CREATE_PURCHASE_ORDER = gql`
  mutation createPurchaseOrder($input: CreatePurchaseOrderInput!) {
    createPurchaseOrder(input: $input) {
      recordId
      orderNumber
      missionsRecordId
      clientSocietyRecordId
      fileUrl
      startDate
      endDate
      amountHT
      invoicedAmountHT
      remainingAmountHT
      useForNonWorkingHours
      invoiceComment
      status
    }
  }
`;

export const UPDATE_PURCHASE_ORDER = gql`
  mutation updatePurchaseOrder($input: UpdatePurchaseOrderInput!) {
    updatePurchaseOrder(input: $input) {
      recordId
      orderNumber
      missionsRecordId
      clientSocietyRecordId
      fileUrl
      startDate
      endDate
      amountHT
      invoicedAmountHT
      remainingAmountHT
      useForNonWorkingHours
      invoiceComment
      status
    }
  }
`;

export const DELETE_PURCHASE_ORDER = gql`
  mutation deletePurchaseOrder($id: ID!) {
    deletePurchaseOrder(id: $id)
  }
`;

export const UPLOAD_PURCHASE_ORDER_FILE = gql`
  mutation uploadPurchaseOrderFile($input: UploadPurchaseOrderFileInput!) {
    uploadPurchaseOrderFile(input: $input) {
      recordId
      orderNumber
      missionsRecordId
      clientSocietyRecordId
      fileUrl
      startDate
      endDate
      amountHT
      invoicedAmountHT
      remainingAmountHT
      useForNonWorkingHours
      invoiceComment
      status
    }
  }
`;

// --- TEC-3052 : contacts & rattachements du tableau de bord de mission ---

const CONTACT_DASHBOARD_FIELDS = gql`
  fragment ContactDashboardFields on Contact {
    recordId
    fullname
    firstname
    lastname
    email
    phoneNumber
    nameJob
    isBilling
    isOperational
    communicationType
  }
`;

export const UPDATE_CONTACT = gql`
  mutation updateContact($input: updateContactInput!) {
    updateContact(input: $input) {
      ...ContactDashboardFields
    }
  }
  ${CONTACT_DASHBOARD_FIELDS}
`;

export const UPSERT_CONTACT = gql`
  mutation upsertContact($input: contactInput!) {
    upsertContact(input: $input) {
      ...ContactDashboardFields
    }
  }
  ${CONTACT_DASHBOARD_FIELDS}
`;

export const LINK_CONTACT_TO_SOCIETY = gql`
  mutation linkContactToSociety($contactId: ID!, $societyId: ID!, $role: ContactSocietyRole!) {
    linkContactToSociety(contactId: $contactId, societyId: $societyId, role: $role) {
      recordId
      billingContacts {
        ...ContactDashboardFields
      }
      legalContacts {
        ...ContactDashboardFields
      }
    }
  }
  ${CONTACT_DASHBOARD_FIELDS}
`;

export const UNLINK_CONTACT_TO_SOCIETY = gql`
  mutation unlinkContactToSociety($contactId: ID!, $societyId: ID!, $role: ContactSocietyRole!) {
    unlinkContactToSociety(contactId: $contactId, societyId: $societyId, role: $role) {
      recordId
      billingContacts {
        ...ContactDashboardFields
      }
      legalContacts {
        ...ContactDashboardFields
      }
    }
  }
  ${CONTACT_DASHBOARD_FIELDS}
`;

export const LINK_CONTACT_TO_MISSION = gql`
  mutation linkContactToMission($contactId: ID!, $missionId: ID!, $role: ContactMissionRole!, $side: ContactSide) {
    linkContactToMission(contactId: $contactId, missionId: $missionId, role: $role, side: $side) {
      recordId
      contactOperations {
        ...ContactDashboardFields
      }
      clientLegalContacts {
        ...ContactDashboardFields
      }
      bloomerLegalContacts {
        ...ContactDashboardFields
      }
      billingContacts {
        ...ContactDashboardFields
      }
    }
  }
  ${CONTACT_DASHBOARD_FIELDS}
`;

export const UNLINK_CONTACT_TO_MISSION = gql`
  mutation unlinkContactToMission($contactId: ID!, $missionId: ID!, $role: ContactMissionRole!, $side: ContactSide) {
    unlinkContactToMission(contactId: $contactId, missionId: $missionId, role: $role, side: $side) {
      recordId
      contactOperations {
        ...ContactDashboardFields
      }
      clientLegalContacts {
        ...ContactDashboardFields
      }
      bloomerLegalContacts {
        ...ContactDashboardFields
      }
      billingContacts {
        ...ContactDashboardFields
      }
    }
  }
  ${CONTACT_DASHBOARD_FIELDS}
`;

export const LINK_SOCIETY_TO_MISSION = gql`
  mutation linkSocietyToMission($societyId: ID!, $missionId: ID!, $role: SocietyMissionRole!) {
    linkSocietyToMission(societyId: $societyId, missionId: $missionId, role: $role) {
      recordId
      clientSociety {
        recordId
        name
      }
      clientBillingSociety {
        recordId
        name
      }
      bloomerBillingSociety {
        recordId
        name
      }
    }
  }
`;

export const UNLINK_SOCIETY_TO_MISSION = gql`
  mutation unlinkSocietyToMission($societyId: ID!, $missionId: ID!, $role: SocietyMissionRole!) {
    unlinkSocietyToMission(societyId: $societyId, missionId: $missionId, role: $role) {
      recordId
      clientSociety {
        recordId
        name
      }
      clientBillingSociety {
        recordId
        name
      }
      bloomerBillingSociety {
        recordId
        name
      }
    }
  }
`;

export const EDIT_CRA_DAYS_MANUAL = gql`
  mutation editCraDaysManual($input: EditCraDaysManualInput!) {
    editCraDaysManual(input: $input) {
      missionId
      missionLabel
      bloomerFullName
      clientSocietyName
      contactOperationsName
      activityId
      activityMonth
      status
      craURL
      signedCount
      bloomerSignatureInfo {
        signedAt
        ip
        signerName
      }
      clientSignatureInfo {
        signedAt
        ip
        signerName
      }
      invoiceURL
      additionalInvoiceURL
      signingDocumentId
      bloomerPayDateDays
      dateUploadInvoice
      bloomerInvoiceBilled
      bloomerInvoiceStatus
      bloomerInvoiceLastError
      supplierInvoiceStatus
      externalSupplierInvoiceId
      externalCustomerInvoiceId
      externalCustomerInvoiceMarkupId
      clientInvoicePennylaneUrl
      clientInvoiceMarkupPennylaneUrl
      bloomerInvoicePennylaneUrl
      bloomerSocietyName
      bloomerSocietyPortage
      clientInvoiceStatus
      clientInvoiceLastError
      clientInvoiceBilled
      jobOwner {
        firstname
        lastname
        email
      }
      bloomerScore
      bloomerComment
      bloomerScoreDate
      clientScore
      clientComment
      clientScoreDate
      nbDaysWorked
      nbDaysMarkupWorked
      nbDaysMarkup2Worked
      nbDaysDetails
      nbDaysAstreinteWorked
      hoursPerDays
      salePricePerDayWithoutTaxes
      purchasePricePerDayWithoutTaxes
      astreinteCoef
      daysManuallyModified
    }
  }
`;
